import React from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { LaunchOutlined } from "@mui/icons-material";
import caseStates from "@_configs/caseStates.config";
import { caseConstants } from "@_constants/case.constants";
import { invoiceTemplateConstants } from "@_constants/invoiceTemplate.constants";
import { formatDatetime } from "@_utils/helpers";
import styles from "./OverviewHeader.module.css";
import { useSelector } from "react-redux";

function OverviewHeader(props) {
  const {
    data,
    activable,
    onAutoLogin,
    onOpenCancelCasePopup,
    onCaseActivation,
    onOpenResetCasePopup,
  } = props;
  const caseActivityReducer = useSelector((state) => {
    return state.caseActivityReducer;
  });

  return (
    <div className={styles.activation_section} data-testid="overview-header">
      <div className={styles.status_container} data-testid="overview-header-status">
        <div className={styles.status_box}>
          <div className={styles.status_icon}>
            {caseStates[data.state].icon}
          </div>
          <div className={styles.status_name} data-testid="overview-header-status-name">
            {caseStates[data.state].name}
          </div>
        </div>
        <div className={styles.status_date} data-testid="overview-header-status-date">
          {formatDatetime(data.date_created, "short")}
        </div>
      </div>

      <div className={styles.host_container}>
        <div className={styles.host} data-testid="overview-header-host">
          {data.host}
        </div>
        <div className={styles.source_id} data-testid="overview-header-source">
          {data.source_case_id} Case ID: {data.case_id}
          {data.state !== "STANDBY" && data.state !== "CANCELLED" && (
            <Tooltip
              title={"View case in settlement portal"}
              placement="bottom-start"
            >
              <Button
                className={styles.btn_view_case}
                data-testid="overview-header-view-case"
                onClick={onAutoLogin}
              >
                View case{" "}
                <LaunchOutlined
                  fontSize="small"
                  className={styles.view_case_icon}
                />
              </Button>
            </Tooltip>
          )}
        </div>
      </div>

      <div className={styles.btn_container}>
        {data.state === "STANDBY" ? (
          <div className={styles.activate_btns_container}>
            <Tooltip title={"Cancel case"} placement="top-start">
              <div
                className={styles.cancel_icon}
                data-testid="overview-header-standby-cancel"
                onClick={onOpenCancelCasePopup}
              >
                {caseStates["CANCELLED"].icon}
              </div>
            </Tooltip>
            <Button
              className={styles.btn_activate}
              data-testid="overview-header-activate"
              onClick={onCaseActivation}
              disabled={!activable}
            >
              ACTIVATE
            </Button>
          </div>
        ) : data.state === "ACTIVE" ? (
          <Tooltip
            title={
              data.invoices?.some(
                (invoice) =>
                  invoice.type === invoiceTemplateConstants.INVOICE_TYPE_ACTIVE,
              )
                ? "This case contains an active invoice and can't be cancelled."
                : ""
            }
            placement="top"
            arrow
          >
            <span>
              <Button
                className={styles.btn_cancel}
                data-testid="overview-header-active-cancel"
                onClick={onOpenCancelCasePopup}
                disabled={caseActivityReducer.activities.some(
                  (activity) =>
                    activity.type ===
                      caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED &&
                    activity.content?.type === "ACTIVE",
                )}
              >
                CANCEL
              </Button>
            </span>
          </Tooltip>
        ) : data.state === "CANCELLED" ? (
          <Button
            className={styles.btn_reset}
            data-testid="overview-header-reset"
            onClick={onOpenResetCasePopup}
          >
            {data.was_activated ? "REACTIVATE" : "RESET"}
          </Button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default OverviewHeader;
